module.exports = __webpack_public_path__ + "packs/media/images/Bigi-f7d1de8438d5eb461aa59cdd258762a7.jpg";